import { render, staticRenderFns } from "./CustomLoader.vue?vue&type=template&id=333c50dc&scoped=true&"
import script from "./CustomLoader.vue?vue&type=script&lang=js&"
export * from "./CustomLoader.vue?vue&type=script&lang=js&"
import style0 from "./CustomLoader.vue?vue&type=style&index=0&id=333c50dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "333c50dc",
  null
  
)

export default component.exports